import { mountNextDoorEvent, NextDoorEvent } from './mountNextDoorEvent';

/**
 * Mount a next door page view event
 */
export function mountNextDoorPageView(): void {
  mountNextDoorEvent(NextDoorEvent.PAGEVIEW);
}
